module.exports = __webpack_public_path__ + "static/media/reboque.0cc17372.png";